<div>
    <div class="modal-bg"></div>
    <div class="modal">
        @if(s_modal().type != "img") {
            <!-- <img class="logo" src="assets/logos/bwa/boss.png" /> -->
            <a class="close" (click)="modal_close()">{{ "< VOLTAR" }}</a>
            <br/><br/><br/>

            <app-form></app-form>

        }
        @else {  
            <a class="close" (click)="modal_close()">{{ "X FECHAR" }}</a>
            <br/>

            <img class="img" src="{{s_modal().img}}" />

        }

    </div>    
</div>    